import { render, staticRenderFns } from "./QuoteStatusActions.vue?vue&type=template&id=8c2cf0a0&"
import script from "./QuoteStatusActions.vue?vue&type=script&lang=ts&"
export * from "./QuoteStatusActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports